import React, { useContext } from 'react';
import { AssignmentFeedbackForm } from 'domains/assignments/Components/AssignmentFeedbackForm';
import { DailyRoutineCtx, withDailyRoutineContext } from 'domains/dailyRoutines/context';
import { dailyRoutineStepId } from 'domains/dailyRoutines/steps';

const SubmitActivity: React.FC = () => {
  const { onComplete, previewMode } = useContext(DailyRoutineCtx);

  return <AssignmentFeedbackForm onSubmit={onComplete} previewMode={previewMode} />;
};

export default withDailyRoutineContext(SubmitActivity, dailyRoutineStepId.submitActivity);
